export default __webpack_public_path__ + "static/alsipinni-0284acc0c4edb8fdb03b1a8e5a6c971e.png";